export default class City {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        cityRetrieve(id: ${id}) {
          id
          name
          latitude
          longitude
          region {
            id
            name
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.cityRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        cityList {
          results {
            id
            name
            latitude
            longitude
            region {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.cityList.results.reverse();
  }

  static async filter(axios, region) {
    const response = await axios.post(
      '/graphql/',
      `query{
        cityList (region: ${region}){
          results {
            id
            name
            latitude
            longitude
            region {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.cityList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteCity(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteCity.ok;
  }

  static async create(axios, name, latitude, longitude, region) {
    const regionField = (region > 0) ? `region: ${region},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createCity(newCity: {
          ${regionField}
          name: "${name}", 
          latitude: "${latitude}", 
          longitude: "${longitude}", 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createCity.ok;
  }


  static async edit(axios, id, name, latitude, longitude, region) {
    const regionField = (region > 0) ? `region: ${region},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateCity(newCity: {
          ${regionField}
          id: ${id},
          name: "${name}", 
          latitude: "${latitude}", 
          longitude: "${longitude}", 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateCity.ok;
  }


}